export const queryKeys = {
  globalGrants: () => ["grants", "global"] as const,
  mspGrants: (parentTenantID: string) =>
    ["grants", "msp", parentTenantID] as const,
  mspTenants: (parentTenantID: string, includeParentTenant?: boolean) =>
    ["mspTenants", parentTenantID, Boolean(includeParentTenant)] as const,
  tenantEvents: (tenantID: string) => ["tenantEvents", tenantID] as const,
};
